import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import Footer from "../components/Footer";
import EditableImage from "../components/EditableImage";
import { EmailGate } from "../components/EmailGate";
import { NAME } from "../config";
import { SLUGS } from "../config";
import { getT } from "../i18n/translations";
import { Check } from "lucide-react";

export default function LangHome({ lang }) {
  const [gateOpen, setGateOpen] = useState(false);
  const navigate = useNavigate();
  const t = getT(lang);

  return (
    <div className="portal" data-testid="lang-home-page">
      <BrandHeader />

      <div className="card fade-up" style={{ animationDelay: "0.06s" }}>
        <EditableImage
          storageKey="langhome-portrait"
          label="PHOTO 2 — portrait"
          style={{ width: "100%", height: 240 }}
          data-testid="langhome-photo"
        />
        <h1
          style={{ fontSize: 28, fontWeight: 800, textAlign: "center", margin: "16px 0 10px" }}
          data-testid="langhome-name"
        >
          {NAME}
        </h1>
        <p style={{ textAlign: "center", color: "var(--ink-soft)", margin: 0 }} data-testid="langhome-tagline">
          {t.tagline}
        </p>
      </div>

      <div className="card fade-up" data-testid="vision-card">
        <h2
          style={{
            fontSize: 20,
            fontWeight: 700,
            margin: "0 0 12px",
            textDecoration: "underline",
            textUnderlineOffset: 5,
          }}
        >
          {t.vision.heading}
        </h2>
        <p style={{ fontStyle: "italic", color: "var(--ink-soft)", margin: 0 }}>
          {t.vision.italic}
        </p>

        <div style={{ marginTop: 6 }}>
          {t.vision.checks.map((c) => (
            <div className="check-row" key={c}>
              <span className="check-badge">
                <Check size={13} strokeWidth={3} />
              </span>
              <span style={{ fontWeight: 500 }}>{c}</span>
            </div>
          ))}
        </div>

        <EditableImage
          storageKey="vision-stage"
          label="PHOTO — Blockchain World stage"
          style={{ width: "100%", height: 190, marginTop: 20 }}
          data-testid="vision-photo"
        />
      </div>
      <nav style={{ display: "flex", flexDirection: "column", gap: 12 }} data-testid="langhome-menu">
        <button
          className="btn"
          data-testid="menu-about"
          onClick={() => navigate(`/${lang}/${SLUGS[lang].about}`)}
        >
          {t.menu.about}
        </button>
        <button
          type="button"
          onClick={() => setGateOpen(true)}
          className="btn"
          data-testid="menu-hub"
        >
          {t.menu.hub}
        </button>
        <button
          className="btn"
          data-testid="menu-contact"
          onClick={() => navigate(`/${lang}/${SLUGS[lang].contact}`)}
        >
          {t.menu.contact}
        </button>
        <button className="btn btn-primary" data-testid="menu-lang-switch" onClick={() => navigate("/")}>
          {t.menu.langSwitch} {t.langSwitchFlags}
        </button>
      </nav>


      <Footer testid="langhome-footer" />

      <EmailGate lang={lang} open={gateOpen} onClose={() => setGateOpen(false)} />
    </div>
  );
}
